import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useCreatePermission } from '@/hooks/mutations/permissions'
import { toast } from 'react-hot-toast'

const CreatePermission = () => {
  const navigate = useNavigate()
  const createPermission = useCreatePermission()
  const [formData, setFormData] = useState({
    title: ''
  })

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      await createPermission.mutateAsync(formData)
      toast.success('Permission created successfully')
      navigate('/permissions')
    } catch (error) {
      toast.error(error.message || 'Failed to create permission')
    }
  }

  return (
    <section className='bg-gray-2 dark:bg-dark py-20'>
      <div className='container mx-auto'>
        <div className='flex flex-wrap -mx-4'>
          <div className='w-full px-4'>
            <div className='relative mx-auto max-w-[800px] overflow-hidden rounded-lg bg-white dark:bg-dark-2 shadow-card'>
              <div className='p-8 sm:p-12'>
                <h2 className='mb-6 text-2xl font-bold text-black dark:text-white'>
                  Create New Permission
                </h2>
                <form onSubmit={handleSubmit}>
                  <div className='mb-6'>
                    <label className='mb-3 block text-sm font-medium text-dark dark:text-white'>
                      Permission Title
                    </label>
                    <input
                      type='text'
                      placeholder='Enter permission title'
                      value={formData.title}
                      onChange={(e) => setFormData({ title: e.target.value })}
                      className='w-full rounded-md border border-stroke dark:border-dark-3 bg-transparent py-3 px-6 text-base text-body-color dark:text-dark-6 placeholder:text-body-color outline-none transition focus:border-primary focus-visible:shadow-none'
                      required
                    />
                  </div>

                  <div className='flex gap-4'>
                    <button
                      type='submit'
                      className='rounded-md bg-primary py-3 px-9 text-base font-medium text-white transition duration-300 ease-in-out hover:bg-opacity-80'
                    >
                      Create Permission
                    </button>
                    <button
                      type='button'
                      onClick={() => navigate('/permissions')}
                      className='rounded-md bg-gray-2 dark:bg-dark-3 py-3 px-9 text-base font-medium text-body-color dark:text-dark-6 transition duration-300 ease-in-out hover:bg-opacity-80'
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CreatePermission 